import React from 'react';
import moment from 'moment';
import { Box, Stack, Tooltip } from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import { Control, useWatch } from 'react-hook-form';
import { DateField } from 'components/form/rhf';

import { DealBuilderFormValues } from '../../../../types';

interface Props {
  rowIndex: number;
  control: Control<DealBuilderFormValues>;
  onFieldBlur: (rowIndex: number) => void;
}

export const PayoffGoodThroughDateCell = ({ control, rowIndex, onFieldBlur }: Props) => {
  const [payoffGoodThroughDate] = useWatch({
    control,
    name: [`pricing.tradeIn.${rowIndex}.payoffGoodThroughDate`],
  });

  // Payoff quotes are only valid through the lender's stated date
  const isExpired = !!payoffGoodThroughDate && moment(payoffGoodThroughDate).isBefore(moment(), 'day');

  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      <Box flex={1}>
        <DateField
          label="Payoff Good-Through Date"
          control={control}
          name={`pricing.tradeIn.${rowIndex}.payoffGoodThroughDate`}
          extraAction={() => onFieldBlur(rowIndex)}
          slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
        />
      </Box>
      {isExpired && (
        <Tooltip arrow title="Payoff quote has expired">
          <WarningAmberOutlined color="warning" fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  );
};
